module.exports = __webpack_public_path__ + "static/img/otp_img.b8f3deb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/otp_img.svg
// module id = VU+I
// module chunks = 7